import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import firebase from 'firebase';
import { firebaseConfig } from './app.firebase.config';
import { ShareServiceService } from './share-service.service';
import { Socket } from 'ngx-socket-io';
import { Router, NavigationExtras } from '@angular/router';
import Swal from 'sweetalert2'
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  public appPages = []

  leads = [] as any
  attend = [] as any
  warranty = [] as any
  tasklist = [] as any
  tasklistCount = [] as any
  finance = [] as any
  request = [] as any
  scpaymentlog = [] as any
  acpaymentlog = [] as any
  today2 = new Date()
  currentMonth = this.today2.getMonth();
  currentYear = this.today2.getFullYear();
  event = [] as any

  sofList = [] as any
  sofListCount = [] as any
  paymentList = [] as any
  paymentListCount = [] as any
  installtionList = [] as any
  installtionListCount = [] as any

  public userid

  constructor(
    private http: HttpClient,
    private nav: NavController,
    public share: ShareServiceService,
    private socket: Socket,
    private router: Router,
    private datepipe: DatePipe,
  ) {
    firebase.initializeApp(firebaseConfig);
  }

  ngOnInit() {
    this.socket.connect();
    const pathname = window.location.pathname;

    firebase.auth().onAuthStateChanged((authUser) => {
      if (authUser || pathname.includes('form=3')) {
        console.log(1);

        this.loadUserDetails(authUser.uid);
      } else if (pathname.includes('form-page')) {
        console.log(2);

      } else {
        this.handleLogout();
      }
    });
  }

  loadUserDetails(uid: string) {
    this.http.post('https://api.nanogapp.com/getUserDetail', { uid }).subscribe((userData) => {
      this.share.user = userData['data'];

      console.log(userData['data']);

      if (!userData['data']) {
        this.handleLogout();
      } else {
        this.setupAppPages();
        this.refreshData();

        // if (this.share.user.user_role == 'Marketing') {
        //   this.nav.navigateRoot('tabs-leads-marketing')

        // }
        // if (this.share.user.user_role == 'Finance') {
        //   this.nav.navigateRoot('tabs-leads')

        // }
        if (this.share.user.user_role == 'Account') {
          this.nav.navigateRoot('tabs-leads-payment')

        }
        console.log('share data', this.share.user);
      }

      // setInterval(() => {
      //   this.refreshData();
      // }, 300000);
    });
  }

  setupAppPages() {
    if (this.share.user.user_role == 'Sales Coordinator') {
      this.appPages = [
        { title: 'Dashboard', url: '/tabs-dashboard', icon: 'timer' },
        {
          title: 'Leads', url: '', icon: 'person', multiple: true, expanded: true, item: [
            { title: 'Pending Appointment', url: '/tabs-leads-pending', icon: 'person' },
            { title: 'Attended Lead', url: '/tabs-leads-attended', icon: 'person' },
            { title: 'Payment Approval', url: '/tabs-leads-payment', icon: 'person' },
            { title: 'Sales Closed', url: '/tabs-leads-sales-closed', icon: 'person' },
            { title: 'My Leads', url: '/tabs-leads-mylead', icon: 'person' },
            { title: 'All Leads', url: '/tabs-leads', icon: 'person' },
            // { title: 'All Customers', url: '/tabs-leads-user', icon: 'person' },
            // { title: 'Warranty', url: '/tabs-leads-warranty', icon: 'person' },
            { title: 'Duplicate Leads', url: '/tabs-leads-duplicate', icon: 'person' },
            { title: 'Request Quotation', url: '/tabs-leads-request', icon: 'person' },]
        },
        // { title: 'Upload', url: '/tabs-upload', icon: 'cloud-upload' },
        { title: 'Users', url: '/tabs-users', icon: 'people' },
        { title: 'Event Calendar', url: '/tabs-calendar-event', icon: 'today' },
        { title: 'Appointment Calendar', url: '/tabs-calendar', icon: 'today' },
        { title: 'Installation Calendar', url: '/tabs-calendar-install', icon: 'today' },
        { title: 'Ads List', url: '/tabs-manage-ads', icon: 'settings' },
      ];
    } else if (this.share.user.user_role == 'Sales Executive') {
      this.appPages = [
        { title: 'Dashboard', url: '/tabs-dashboard', icon: 'timer' },
        {
          title: 'Leads', url: '', icon: 'person', multiple: true, expanded: true, item: [
            { title: 'Pending Appointment', url: '/tabs-leads-pending', icon: 'person' },
            { title: 'My Leads', url: '/tabs-leads-mylead', icon: 'person' },
            { title: 'All Leads', url: '/tabs-leads', icon: 'person' },
            // { title: 'All Customers', url: '/tabs-leads-user', icon: 'person' },
            { title: 'Warranty', url: '/tabs-leads-warranty', icon: 'person' },
            { title: 'Duplicate Leads', url: '/tabs-leads-duplicate', icon: 'person' },]
        },
        { title: 'Event Calendar', url: '/tabs-calendar-event', icon: 'today' },
        { title: 'Appointment Calendar', url: '/tabs-calendar', icon: 'today' },
      ];
    } else if (this.share.user.user_role == 'Project Coordinator') {
      this.appPages = [
        { title: 'Dashboard', url: '/tabs-dashboard', icon: 'timer' },
        {
          title: 'Leads', url: '', icon: 'person', multiple: true, expanded: true, item: [
            // { title: 'Pending Appointment', url: '/tabs-leads-pending', icon: 'person' },
            { title: 'Pending Tasklist', url: '/tabs-leads-tasklist', icon: 'person' },
            // { title: 'My Leads', url: '/tabs-leads-mylead', icon: 'person' },
            // { title: 'All Leads', url: '/tabs-leads', icon: 'person' },
            // { title: 'All Customers', url: '/tabs-leads-user', icon: 'person' },
            // { title: 'Warranty', url: '/tabs-leads-warranty', icon: 'person' },
            // { title: 'Duplicate Leads', url: '/tabs-leads-duplicate', icon: 'person' },
          ]
        },
        { title: 'Event Calendar', url: '/tabs-calendar-event', icon: 'today' },
        { title: 'Installation Calendar', url: '/tabs-calendar-install', icon: 'today' },
      ];
    } else if (this.share.user.user_role == 'Finance') {
      this.appPages = [
        // { title: 'Dashboard', url: '/tabs-dashboard', icon: 'timer' },
        { title: 'Dashboard', url: '/tabs-dashboard', icon: 'timer' },
        {
          title: 'Leads', url: '', icon: 'person', multiple: true, expanded: true, item: [
            // { title: 'Pending Appointment', url: '/tabs-leads-pending', icon: 'person' },
            { title: 'Payment Approval', url: '/tabs-leads-payment', icon: 'person' },
            { title: 'Sales Closed', url: '/tabs-leads-sales-closed', icon: 'person' },
            { title: 'All Leads', url: '/tabs-leads', icon: 'person' },
            // { title: 'All Customers', url: '/tabs-leads-user', icon: 'person' },
            // { title: 'Warranty', url: '/tabs-leads-warranty', icon: 'person' },
            { title: 'Duplicate Leads', url: '/tabs-leads-duplicate', icon: 'person' },]
        },
        { title: 'Event Calendar', url: '/tabs-calendar-event', icon: 'today' },
        { title: 'Appointment Calendar', url: '/tabs-calendar', icon: 'today' },
        { title: 'Finance Task', url: '/tabs-finance-task', icon: 'calculator' },
      ];
    } else if (this.share.user.user_role == 'Account') {
      this.appPages = [
        // { title: 'Dashboard', url: '/tabs-dashboard', icon: 'timer' },
        {
          title: 'Leads', url: '', icon: 'person', multiple: true, expanded: true, item: [
            { title: 'Payment Approval', url: '/tabs-leads-payment', icon: 'person' },
            { title: 'Sales Closed', url: '/tabs-leads-sales-closed', icon: 'person' },
            { title: 'All Leads', url: '/tabs-leads', icon: 'person' },
            // { title: 'All Customers', url: '/tabs-leads-user', icon: 'person' },
          ]
        },
        { title: 'Event Calendar', url: '/tabs-calendar-event', icon: 'today' },
        { title: 'Appointment Calendar', url: '/tabs-calendar', icon: 'today' },
      ];
    } else if (this.share.user.user_role == 'Marketing') {
      this.appPages = [
        { title: 'Dashboard', url: '/tabs-dashboard', icon: 'timer' },
        { title: 'My Media', url: '/tabs-leads-marketing-media', icon: 'person' },
        { title: 'Photo Corner', url: '/tabs-leads-marketing', icon: 'person' },
        { title: 'Marketing Tasks', url: '/tabs-leads-marketing-tasks', icon: 'person' },
        { title: 'Manage Ads', url: '/tabs-manage-ads', icon: 'settings' },
        { title: 'Manage Ads Platform', url: '/tabs-manage-ads-platform', icon: 'settings' },
      ];
    } else {
      this.appPages = [
        { title: 'Dashboard', url: '/tabs-dashboard', icon: 'timer' },
        {
          title: 'Leads', url: '', icon: 'person', multiple: true, expanded: true, item: [
            { title: 'Pending Appointment', url: '/tabs-leads-pending', icon: 'person' },
            // { title: 'My Leads', url: '/tabs-leads-mylead', icon: 'person' },
            { title: 'Attended Lead', url: '/tabs-leads-attended', icon: 'person' },
            { title: 'Sales Closed', url: '/tabs-leads-sales-closed', icon: 'person' },
            { title: 'All Leads', url: '/tabs-leads', icon: 'person' },
            // { title: 'All Customers', url: '/tabs-leads-user', icon: 'person' },
            { title: 'Warranty', url: '/tabs-leads-warranty', icon: 'person' },
            // { title: 'Maintenance', url: '/tabs-leads-maintenance', icon: 'person' },
            { title: 'Duplicate Leads', url: '/tabs-leads-duplicate', icon: 'person' },
            { title: 'Request Quotation', url: '/tabs-leads-request', icon: 'person' },]
        },
        // { title: 'Upload', url: '/tabs-upload', icon: 'cloud-upload' },
        { title: 'Users', url: '/tabs-users', icon: 'people' },
        { title: 'Event Calendar', url: '/tabs-calendar-event', icon: 'today' },
        { title: 'Appointment Calendar', url: '/tabs-calendar', icon: 'today' },
        { title: 'Installation Calendar', url: '/tabs-calendar-install', icon: 'today' },
        { title: 'Finance Task', url: '/tabs-finance-task', icon: 'calculator' },
        // { title: 'Settings', url: '/tabs-settings', icon: 'settings' },
        // { title: 'Manage Issues', url: '/tabs-manage-issues', icon: 'search-circle' },
        {
          title: 'Manages', url: '', icon: 'settings', multiple: true, expanded: false, item: [
            { title: 'Manage Labels', url: '/tabs-manage-labels', icon: 'settings' },
            { title: 'Manage Packages', url: '/tabs-manage-packages', icon: 'settings' },
            { title: 'Manage Payment', url: '/tabs-manage-payment', icon: 'settings' },
            { title: 'Manage Channel', url: '/tabs-manage-channel', icon: 'settings' },
            { title: 'Manage Ads', url: '/tabs-manage-ads', icon: 'settings' },
            { title: 'Manage Ads Platform', url: '/tabs-manage-ads-platform', icon: 'settings' },
            { title: 'Manage Equipment', url: '/tabs-manage-equipment', icon: 'settings' },
            { title: 'Manage Discounts', url: '/tabs-manage-discounts', icon: 'settings' },
            { title: 'Manage Promo Codes', url: '/tabs-manage-promo-codes', icon: 'settings' },
            { title: 'Manage Sub-Con', url: '/tabs-manage-company', icon: 'settings' },
            { title: 'Manage Places', url: '/tabs-manage-places', icon: 'settings' },
          ]
        },

      ];
    }
  }

  refreshData() {
    if (
      this.share.user.user_role === 'Super Admin' ||
      this.share.user.user_role === 'System Admin' ||
      this.share.user.user_role === 'Sales Coordinator'
    ) {
      this.loadLeadsData();
      this.loadAttendedLead()
    }

    if (this.share.user.user_role === 'Project Coordinator') {
      this.loadTaskListData();
    }

    if (this.share.user.user_role === 'Sales Coordinator') {
      this.loadSCPaymentLogData();
    }

    if (this.share.user.user_role === 'Account' || this.share.user.user_role === 'Finance') {
      this.loadACPaymentLogData();
    }

    if (this.share.user.user_role === 'Finance') {
      this.loadFinanceData();
    }

    this.loadQuotationRequestData();
    this.loadEventData();
  }

  loadLeadsData() {
    this.http.post('https://api.nanogapp.com/getPendingAppointment', { user_role: this.share.user.user_role, user_uid: this.share.user.uid }).subscribe((s) => {
      if (this.share.user.user_role == 'Super Admin' || this.share.user.user_role == 'System Admin') {
        this.leads = s['data'].filter(a => a.label_s_id == '2')
      } else if (this.share.user.user_role == 'Sales Coordinator') {
        this.leads = s['data'].filter(a => a.label_s_id == '2').filter(a => a.sales_coord_uid == this.share.user.uid)
      }
      this.leads = this.leads.filter(a => a.label_s_id != '80')
      console.log(this.leads);

      this.loadWarrantyData();

    })
  }

  loadAttendedLead() {
    let date = new Date();
    let from_date = this.datepipe.transform(new Date(date.getFullYear(), date.getMonth() - 1, 1).setHours(0, 0, 0, 1), 'yyyy-MM-dd')
    let to_date = this.datepipe.transform(new Date(date.getFullYear(), date.getMonth() + 1, 0).setHours(23, 59, 59, 999), 'yyyy-MM-dd')
    this.http.post('https://api.nanogapp.com/getLeadListAttended', {
      startDate: new Date(from_date).getTime() - 28800000, endDate: new Date(to_date).getTime() + 57599000
    }).subscribe((s) => {
      this.attend = s['data']

    });
  }

  loadWarrantyData() {
    this.http.post('https://api.nanogapp.com/getWarrantyList', { user_role: this.share.user.user_role, user_uid: this.share.user.uid }).subscribe((s) => {
      this.warranty = s['data'].sort((a, b) => b.created_date - a.created_date)
      console.log('Warranty', this.warranty);

      this.loadSOFListData();

    })
  }

  loadSOFListData() {

    this.http.post('https://api.nanogapp.com/getLeadList3SOFversion2', { startDate: 1441944818000, endDate: 1915330418000 }).subscribe((s) => {
      this.sofList = s['data']
      console.log('SOF List', this.sofList);

      this.loadPaymentListData();

    })
  }

  loadPaymentListData() {
    this.http.post('https://api.nanogapp.com/getLeadList3paymentversion ', { startDate: 1441944818000, endDate: 1915330418000 }).subscribe((s) => {

      this.paymentList = this.share.user.user_role == 'Sales Coordinator' ? s['data'].filter(a => a.sales_coord == this.share.user.user_name) : s['data']
      this.paymentListCount = this.paymentList.length - this.paymentList.filter(a => a.sales_status == 'Full Payment').length

      console.log('Payment List', this.paymentList);

      // this.loadInstallationListData();

    })
  }

  loadInstallationListData() {
    this.http.post('https://api.nanogapp.com/getLeadList3scheduleversion ', { startDate: 1441944818000, endDate: 1915330418000 }).subscribe((s) => {

      this.installtionList = this.share.user.user_role == 'Sales Coordinator' ? s['data'].filter(a => a.sales_coord == this.share.user.user_name) : s['data']
      this.installtionListCount = this.installtionList.length - this.installtionList.filter(a => a.subcon_state == 'Accepted').length

      console.log('Installation List', this.installtionList);
    })
  }

  loadTaskListData() {
    this.http.post('https://api.nanogapp.com/getLeadList3scheduleversion', { startDate: 1441944818000, endDate: 1915330418000 }).subscribe((s) => {
      this.tasklist = s['data']
      this.tasklistCount = this.tasklist.length - this.tasklist.filter(a => a.subcon_state == 'Accepted').length
      console.log('tasklist', this.tasklist);
    })
  }

  loadSCPaymentLogData() {
    if (this.share.user.user_role == 'Sales Coordinator') {
      this.http.get('https://api.nanogapp.com/getScPaymentLog').subscribe((s) => {
        this.scpaymentlog = s['data'].filter(a => a.sales_status != 'Full Payment' && a.sales_coord != 'Old Data').filter(a => a.sc_approval == null).sort((a, b) => a.id - b.id)
        console.log('SCpaymentlog', this.scpaymentlog);
      })
    }
  }

  loadACPaymentLogData() {
    if (this.share.user.user_role == 'Account') {
      this.http.get('https://api.nanogapp.com/getAcPaymentLog').subscribe((s) => {
        this.acpaymentlog = s['data'].filter(a => a.sales_status != 'Full Payment' && a.sales_coord != 'Old Data').filter(a => a.ac_approval == null).sort((a, b) => a.id - b.id)
        console.log('ACCpaymentlog', this.acpaymentlog);
      })
    }
  }

  loadFinanceData() {
    this.http.get('https://api.nanogapp.com/getAllLeadList').subscribe((s) => {
      console.log(s['data']);

      this.finance = s['data'].filter(a => a.whole_status)
      console.log(this.finance);

    })
  }

  loadQuotationRequestData() {
    this.http.get('https://api.nanogapp.com/getLeadList3ForQuotationRequest2').subscribe((s) => {
      if (this.share.user.user_role == 'Sales Coordinator') {
        this.request = s['data'].filter(a => a.sales_coordinator == this.share.user.uid && !a.quotation_submit_date)
      } else {
        this.request = s['data'].filter(a => !a.quotation_submit_date)
      }

      Swal.close()
    })
  }

  loadEventData() {
    let firstDay = new Date(this.today2.getFullYear(), this.today2.getMonth(), 1).setHours(0, 0, 0, 1)
    let lastDay = new Date(this.today2.getFullYear(), this.today2.getMonth() + 150, 0).setHours(23, 59, 59, 999)
    console.log(firstDay, lastDay);

    this.http.post('https://api.nanogapp.com/getEventByDate', { starttime: firstDay, endtime: lastDay }).subscribe((s) => {
      if (this.share.user.user_role == 'Super Admin' || this.share.user.user_role == 'System Admin') {
        this.event = s['data'].filter(a => a.starttime >= new Date().getTime() && a.starttime <= lastDay)
      } else {
        this.event = s['data'].filter(a => a.starttime >= new Date().getTime() && a.starttime <= lastDay).filter(a => a.members.includes(this.share.user.uid));
      }

      console.log(this.event);

    })
  }

  logout() {
    Swal.fire({
      title: 'Logout',
      text: 'Are you sure to logout?',
      icon: 'question',
      showCancelButton: true,
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirm',
      heightAuto: false,
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.handleLogout();
      }
    });
  }

  handleLogout() {
    firebase.auth().signOut().then(() => {
      this.socket.disconnect();
      // this.nav.navigateRoot('login');

      const navigationExtras: NavigationExtras = {
        skipLocationChange: true,  // skip the location change so the URL stays the same
        replaceUrl: true  // replace the current entry in the history stack
      };

      // Navigate to the login page with specified navigation options
      this.router.navigate(['/login'], navigationExtras);
    });
  }
}



